import $ from 'jquery'
import { createAlert } from 'dom/window'
// import _ from 'lodash';
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import config from '../store/_config'
import { convertAvailableDeliveryAddressesToReact, buildNewAddressData } from '../selectors/converterSelectors'
import { getUserCredentials, setUserCredentials } from './userActions'

// TODO: dynamic url (fetchURL)
//       - requestCart
//       - checkout
export const toggleAddressLoading = (key, value) => {
  return {
    type: 'TOGGLE_DELIVERY_ADDRESS_LOADING',
    key: key,
    value: value,
  }
}
export const handleNewAddressFieldUpdate = (key, value) => {
  return {
    type: 'UPDATE_NEW_ADDRESS_FORM',
    key: key,
    value: value,
  }
}
export const updateDeliveryAddresses = (value) => {
  return {
    type: 'UPDATE_AVAILABLE_DELIVERY_ADDRESSES',
    value: value,
  }
}
export const setPermission = (value) => {
  return {
    type: 'SET_AVAILABLE_DELIVERY_ADDRESS_PERMISSION',
    value: value,
  }
}
/**
 * Request Delivery Addresses using plain Silverstripe instead of GraphQL to improve speed
 *
 * @returns {Function}
 */
export const requestDeliveryAddresses = () => {
  return (dispatch, getState) => {
    let state = getState()
    const customerID = state.user.user

    if (customerID) {
      dispatch(toggleAddressLoading('deliveryAddresses', true))

      return axiosRequestDeliveryAddresses({
        isSupplier: false,
      })
        .then((response) => {
          // Delivery Addresses
          const list = convertAvailableDeliveryAddressesToReact(response.data.data.readAddresss.edges)
          let enDefaultAddressLocal = 0
          list.map((item) => {
            if (item.enDefaultltAddress) {
              enDefaultAddressLocal = item.id
            }
          })
          dispatch(
            setUserCredentials({
              defaultDeliveryAddressID: enDefaultAddressLocal,
            })
          )
          dispatch(updateDeliveryAddresses(list))
        })
        .catch((error) => {
          handleAxiosErrors(error)
        })
        .then(() => {
          dispatch(toggleAddressLoading('deliveryAddresses', false))
        })
    }
  }
}

export const axiosRequestDeliveryAddresses = (deliveryOption) => {
  const { isSupplier } = deliveryOption
  let { url, query } = config.members.addresses

  let isOrderOnBehalfOf = isSupplier

  if (window.placeOnBehalfOfID !== undefined && window.placeOnBehalfOfID > 0) {
    isOrderOnBehalfOf = true
  }

  query = query.replace(/{PurchasingUser}/, isOrderOnBehalfOf)

  return axios.get(url, {
    params: {
      query,
    },
    withCredentials: true,
  })
}

export const processNewAddressForm = () => {
  return (dispatch, getState) => {
    const state = getState()
    const formData = buildNewAddressData(state.addresses.newAddressForm, state.user.user)

    let { url, query } = config.members.newAddress

    dispatch(toggleAddressLoading('newAddressForm', true))

    let customerID = 0
    if (window.placeOnBehalfOfID !== undefined && window.placeOnBehalfOfID > 0) {
      customerID = window.placeOnBehalfOfID
    }

    const isOrderOnBehalfOf = customerID ? true : false
    query = query.replace(/{PurchasingUser}/, isOrderOnBehalfOf)

    return axios
      .post(url, {
        query: query,
        variables: formData,
      })
      .then((response) => {
        //const data = response.data;
        dispatch(toggleAddressLoading('newAddressForm', false))

        dispatch(clearNewAddressForm())
        dispatch(requestDeliveryAddresses())

        // close form
        const $newAddressFormTab = $('#new-address')
        if ($newAddressFormTab.length) {
          $newAddressFormTab.removeClass('active')
        }

        const $defaultAddressTab = $('#default-address')
        if ($defaultAddressTab.length) {
          $defaultAddressTab.addClass('active')
        }
      })
      .catch((error) => {
        handleAxiosErrors(error)
        dispatch(toggleAddressLoading('newAddressForm', false))
      })
  }
}
export const makeDefaultAddress = (addressID) => {
  return (dispatch, getState) => {
    let state = getState()

    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0

    if (customerID && addressID) {
      let { url, query } = config.members.setDefaultAddress

      dispatch(toggleAddressLoading('makeDefaultForm', true))

      return axios
        .post(
          url,
          {
            query: query,
            variables: {
              DeliveryAddressID: addressID,
            },
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          const { data } = response
          dispatch(toggleAddressLoading('makeDefaultForm', false))

          if (response.data.data.updateMemberInfo) {
            dispatch(getUserCredentials())
          } else {
            createAlert(data, 'error')
          }
        })
        .catch((error) => {
          handleAxiosErrors(error)
          dispatch(toggleAddressLoading('makeDefaultForm', false))
        })
    }
  }
}
export const removeAddress = (addressID) => {
  return (dispatch, getState) => {
    let state = getState()

    const customerID = typeof state.user.user != 'undefined' ? state.user.user : 0
    const defaultDeliveryAddressID = typeof state.user.user != 'undefined' ? state.user.defaultDeliveryAddressID : 0

    if (customerID && addressID) {
      if (parseInt(addressID) === parseInt(defaultDeliveryAddressID)) {
        createAlert({ message: "You can't remove default address!" }, 'error')
        dispatch(toggleAddressLoading('removeButton', false))
        return
      }

      let { url, query } = config.members.removeAddress

      dispatch(toggleAddressLoading('removeButton', true))

      let customerID = 0
      if (window.placeOnBehalfOfID !== undefined && window.placeOnBehalfOfID > 0) {
        customerID = window.placeOnBehalfOfID
      }

      const isOrderOnBehalfOf = customerID ? true : false
      query = query.replace(/{PurchasingUser}/, isOrderOnBehalfOf)

      return axios
        .post(url, {
          query: query,
          variables: {
            ID: addressID,
          },
        })
        .then((response) => {
          const { data } = response
          dispatch(toggleAddressLoading('removeButton', false))

          dispatch(requestDeliveryAddresses())
        })
        .catch((error) => {
          handleAxiosErrors(error)
          dispatch(toggleAddressLoading('removeButton', false))
        })
    }
  }
}
export const clearNewAddressForm = () => {
  return {
    type: 'CLEAR_NEW_ADDRESS_FORM',
  }
}
export const axiosCreateConfirmDeliveryDetails = (postData) => {
  console.log(postData, 'postData inside action')
  let { url, query } = config.members.createConfirmDeliveryDetails

  return axios.post(
    url,
    {
      query: query,
      variables: postData,
    },
    {
      withCredentials: true,
    }
  )
}

export const handleGoogleAddressChecker = (address) => {
  return (dispatch, getState) => {
    if (address !== null && address.address_components) {
      const streetNumber = getAddressComponent('street_number', address.address_components)
      const streetName = getAddressComponent('route', address.address_components)
      const postalCode = getAddressComponent('postal_code', address.address_components)
      const suburb = getAddressComponent('locality', address.address_components)
      dispatch(handleNewAddressFieldUpdate('streetNumber', streetNumber))
      dispatch(handleNewAddressFieldUpdate('streetName', streetName))
      dispatch(handleNewAddressFieldUpdate('postcode', postalCode))
      dispatch(handleNewAddressFieldUpdate('suburb', suburb))
    }
  }
}

export const getAddressComponent = (key, addressComponents) => {
  let data = ''
  addressComponents.forEach((address) => {
    if (address?.types && address.types.includes(key)) {
      data = address.long_name
    }
  })
  return data
}
